import BoardPage, { boardQuery } from "@app/pages/board/board-page";
import type { boardPage_Query } from "@app/queries/boardPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/board")({
  loader: () =>
    loadQuery<boardPage_Query>(
      environment,
      boardQuery,
      {},
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Board"),
  component: BoardRoute,
});

function BoardRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading board report</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Convening the board...</div>
        }
      >
        <BoardPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
